import { useState, useEffect } from "react";

import { useAuthContext } from "../../../hooks/useAuthContext";

import { httpGet, httpPost, httpPatch } from "../../../api";

import MDPopup from "../../../components/MDPopup";
import MDTypography from "../../../components/MDTypography";
import MDBox from "../../../components/MDBox";
import MDButton from "../../../components/MDButton";
import MDInput from "../../../components/MDInput";
import MDSelect from "../../../components/MDSelect";

import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import CachedIcon from '@mui/icons-material/Cached';


const Page = (props) => {
	const { user } = useAuthContext();

	const [validSubmit, setValidSubmit] = useState(false);

	const [clientFirstName, setClientFirstName] = useState("");
	const [clientSecondName, setClientSecondName] = useState("");
	const [clientEmail, setClientEmail] = useState("");
	const [clientPassword, setClientPassword] = useState("");

	useEffect(() => {
		setValidSubmit(false)
	}, [props.open])

	useEffect(() => {
		setValidSubmit(
			clientFirstName.length > 0 &&
			clientSecondName.length > 0 &&
			clientEmail.length > 0 &&
			clientPassword.length > 0
		)
	}, [clientFirstName, clientSecondName, clientEmail, clientPassword])

	const handleSubmit = async () => {
		const response = await httpPost(process.env.REACT_APP_URL_BASE+`/user/create`, {
				first_name: clientFirstName,
				second_name: clientSecondName,
				email: clientEmail,

				password1: clientPassword,
				password2: clientPassword
			})

		if (response.status != 201 && response.status != 200){
            alert("Something went wrong");
            console.log(response);
            return
        }

        props.setRefreshed(true);
        props.close();
	}

	const [showPassword, setShowPassword] = useState(false);

	const handleClickShowPassword = () => setShowPassword((show) => !show);

	const handleMouseDownPassword = (event: MouseEvent<HTMLButtonElement>) => {
		event.preventDefault();
	};

	const handleMouseUpPassword = (event: MouseEvent<HTMLButtonElement>) => {
		event.preventDefault();
	};

	function generateRandomPassword(length = 12) {
		const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()-_=+";
		let password = "";
		for (let i = 0; i < length; i++) {
		password += chars.charAt(Math.floor(Math.random() * chars.length));
		}
		return password;
	}

	const handleGeneratePassword = () => {
		setClientPassword(generateRandomPassword(Math.floor(Math.random() * 10) + 10));
	}

	return <>
		<MDPopup display="flex" flexDirection="column" justifyContent="center" alignItems="center" open={props.open}>
	        <MDTypography variant="h3" color="info" textAlign="center" fontWeight="bold">Add new client</MDTypography>

	        <br />

	        <MDBox width="50%">
	          <MDTypography variant="h6" color="text">First Name</MDTypography>
	          <MDInput type="text" onChange={(e) => setClientFirstName(e.target.value)} sx={{width: "100%"}} />
	        </MDBox>


	        <br />

	        <MDBox width="50%">
	          <MDTypography variant="h6" color="text">Second Name :</MDTypography>
	          <MDInput type="text" onChange={(e) => setClientSecondName(e.target.value)} sx={{width: "100%"}} />
	        </MDBox>

	        <br />

	        <MDBox width="50%">
	          <MDTypography variant="h6" color="text">Email :</MDTypography>
	          <MDInput type="email" onChange={(e) => setClientEmail(e.target.value)} sx={{width: "100%"}} />
	        </MDBox>

	        <br />

	        <MDBox width="50%">
	          <MDTypography variant="h6" color="text">Password :</MDTypography>
	          <MDBox sx={{display: "flex"}}>

		          <MDInput type={showPassword ? "text" : "password"} value={clientPassword} onChange={(e) => setClientPassword(e.target.value)} sx={{width: "100%"}} />
		          <IconButton
	                  aria-label={
	                    showPassword ? 'hide the password' : 'display the password'
	                  }
	                  onClick={handleClickShowPassword}
	                  onMouseDown={handleMouseDownPassword}
	                  onMouseUp={handleMouseUpPassword}
	                >
	                  {showPassword ? <VisibilityOff /> : <Visibility />}
	                </IconButton>

	                <IconButton
	                	aria-label="generate"
	                	onClick={handleGeneratePassword}
	                >
	                	<CachedIcon />
	                </IconButton>
	           </MDBox>
	        </MDBox>

	        <br />

	        <MDBox width="70%" textAlign="center">
	          <MDButton onClick={handleSubmit} disabled={!validSubmit} variant="text" color="success">Save</MDButton>
	          <MDButton variant="outlined" color="error" onClick={props.close}>Cancel</MDButton>
	        </MDBox>
	    </MDPopup>
	</>
}

export default Page